import React, { useState } from 'react';
import Select from 'react-select';
import './Style.css';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';

const Login = () => {
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate()

  const hospitals = [
    { value: 'hospitalA', label: 'Hospital A' },
    { value: 'hospitalB', label: 'Hospital B' },
    { value: 'hospitalC', label: 'Hospital C' },
    { value: 'hospitalD', label: 'Hospital D' },
  ];

  const validateEmail = (email) => {
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Both fields are required!');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address!');
      return;
    }

    if (password.length < 8) {
      setError('Password must be at least 8 characters long!');
      return;
    }

    console.log('Selected Hospital:', selectedHospital?.label);
    console.log('Email:', email);
    console.log('Password:', password);
      try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/hospital-members/login`, { emailOrPhoneNumber: email, password });
        console.log("login response : ", res.data);
        if (res.data.error) {
          throw new Error(res.data.error);
        }
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('userDetails', JSON.stringify(res.data.userDetails));
        sessionStorage.setItem('filteredRoles', JSON.stringify(res.data.filteredRoles));
        toast.success(res.data.message, { duration: 2000, "position": "top-center" });
        setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
      } catch (error) {
        console.log("Error in the logon", error);
        toast.error(
          error.response?.data?.error || "An unexpected error occurred.",
          { duration: 2000, position: "top-center" }
        );
      }
    };

    return (
      <div className="login-container">
        <form onSubmit={handleLogin} className="login-form">
          <h2>Login</h2>

          <div className="input-field">
            <label htmlFor="hospital-select">Select Hospital</label>
            <Select
              id="hospital-select"
              options={hospitals}
              value={selectedHospital}
              onChange={(selectedOption) => setSelectedHospital(selectedOption)}
              placeholder="Search or select a hospital"
              className="hospital-select"
              isSearchable
            />
          </div>

          {selectedHospital && (
            <>
              {error && <p className="error">{error}</p>}

              <div className="input-field">
                <label htmlFor="email">Email</label>
                <div className="input-wrapper">
                  <FaEnvelope className="icon" />
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              <div className="input-field">
                <label htmlFor="password">Password</label>
                <div className="input-wrapper">
                  <FaLock className="icon" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="toggle-visibility"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                  </span>
                </div>
              </div>

              <button type="submit" className="login-button">
                Login
              </button>
            </>
          )}

          <div className="form-links">
            <a href="#forgot-password" className="forgot-password">
              Forgot Password?
            </a>
            <a href="#create-account" className="create-account">
              Create Account
            </a>
          </div>
        </form>
      </div>
    );
  };

  export default Login;
